<template>
  <div class="container">
    <div v-wechat-title="($route.meta.title = headline)"></div>
    <van-pull-refresh v-model="isLoading" @refresh="onRefresh">
      <div class="allBox" @click.stop="closeBtmModule" @scroll="scrollToBottom">
        <div class="content">
          <div
            class="message-list"
            id="message-list"
            style="overflow-y: auto; overflow-x: hidden"
          >
            <div class="more" v-if="!isCompleted">查看更多</div>
            <div class="no-more" v-else>没有更多了</div>
            <message-item
              v-for="message in currentMessageList"
              :key="message.ID"
              :message="message"
            />
          </div>
        </div>
      </div>
    </van-pull-refresh>
    <div class="bottom">
      <div class="bottom-div">
        <input
          class="input"
          type="text"
          v-model="messageContent"
          @focus="focus = true"
          @blur="focus = false"
          @keydown.enter="handleEnter"
        />
        <div class="btn btn-left" @click.stop="handleEmoji">
          <img src="../../../static/images/chat/smile.png" />
        </div>
        <div
          class="send"
          @click.stop="sendTextMessage"
          v-if="messageContent != null && messageContent.length != 0"
        >
          发送
        </div>
        <div
          class="btn"
          @click.stop="handleMore"
          v-else
          style="margin-left: 15px"
        >
          <img src="../../../static/images/chat/more.png" />
        </div>
      </div>

      <!--更多部分-->
      <div class="bottom-image" v-if="isMoreOpen">
        <div class="images">
          <div class="block">
            <div class="image" @click="handleSendcImageClick">
              <img
                src="../../../static/images/chat/take-pic.png"
                class="icon"
              />
              <input
                type="file"
                id="cimagePicker"
                ref="cimagePicker"
                accept="image/*"
                @change="sendcImage"
                style="display: none"
              />
            </div>
            <div class="name">拍摄</div>
          </div>
          <div class="block" @click="handleSendImageClick">
            <div class="image">
              <img src="../../../static/images/chat/picture.png" class="icon" />
              <input
                type="file"
                id="imagePicker"
                ref="imagePicker"
                accept="image/*"
                @change="sendImage"
                style="display: none"
              />
            </div>
            <div class="name">图片</div>
          </div>
        </div>
      </div>

      <!-- emoji部分-->
      <div class="bottom-emoji" v-if="isEmojiOpen">
        <div class="emoji-tab">
          <div class="tabs">
            <div class="single" :class="emojiShow ? 'choosed' : ''">
              <img
                src="../../../static/images/chat/smile.png"
                style="width: 100%; height: 100%"
              />
            </div>
          </div>
        </div>
        <div class="emojis" v-if="emojiShow">
          <div
            v-for="(item, index) in emojiName"
            class="emoji"
            :key="index"
            @click.stop="chooseEmoji(item)"
          >
            <img
              :src="emojiUrl + emojiMap[item]"
              style="width: 100%; height: 100%"
            />
          </div>
        </div>
      </div>
    </div>
    <image-previewer />
  </div>
</template>
<script>
import { emojiName, emojiMap, emojiUrl } from "@/utils/emojiMap";
import { mapState, mapGetters } from "vuex";
import MessageItem from "../../components/message/message-item";
import ImagePreviewer from "../../components/message/image-previewer";
import { PullRefresh, Toast } from "vant";
export default {
  name: "chat",
  components: {
    MessageItem,
    ImagePreviewer,
    "van-pull-refresh": PullRefresh,
    Toast,
  },
  data() {
    return {
      headline: "",
      // 信息发送
      messageContent: "",
      messageList: [],
      messageContent: "",
      //更多打开
      isMoreOpen: false,
      //表情
      emojiUrl: emojiUrl,
      emojiName: emojiName,
      emojiMap: emojiMap,
      isEmojiOpen: false,
      emojiShow: true,
      conversationID: "",
      isLoading: false,
      isHeight: false,
    };
  },
  watch: {},
  computed: {
    ...mapGetters(["toAccount", "currentConversationType"]),
    ...mapState({
      isCompleted: (state) => state.conversation.isCompleted,
      currentConversation: (state) => state.conversation.currentConversation,
      currentMessageList: (state) => state.conversation.currentMessageList,
    }),
  },
  methods: {
    // 发送信息
    handleEnter() {
      this.sendTextMessage();
    },

    sendTextMessage() {
      if (
        this.messageContent === "" ||
        this.messageContent.trim().length === 0
      ) {
        this.messageContent = "";
        this.$store.commit("showMessage", {
          message: "不能发送空消息哦！",
          type: "info",
        });
        return;
      }
      const message = this.tim.createTextMessage({
        to: this.toAccount,
        conversationType: this.currentConversationType,
        payload: { text: this.messageContent },
      });
      this.$store.commit("pushCurrentMessageList", message);
      this.scrollToBottom();
      this.tim.sendMessage(message).catch((error) => {
        this.$store.commit("showMessage", {
          type: "error",
          message: error.message,
        });
      });
      this.isEmojiOpen = false;
      this.isMoreOpen = false;
      this.messageContent = "";
    },

    handleLine() {
      this.messageContent += "\n";
    },
    //关闭底部模块
    closeBtmModule() {
      this.isEmojiOpen = false;
      this.isMoreOpen = false;
      this.isHeight = !this.isHeight;
    },

    //更多打开
    handleMore() {
      this.isEmojiOpen = false;
      this.isMoreOpen = !this.isMoreOpen;
      this.isHeight = !this.isHeight;
    },

    //表情打开
    handleEmoji() {
      this.isMoreOpen = false;
      this.isEmojiOpen = !this.isEmojiOpen;
      this.isHeight = true;
    },
    //表情选择
    chooseEmoji(item) {
      this.messageContent += item;
    },

    //发图片
    handleSendImageClick() {
      this.$refs.imagePicker.click();
    },
    sendImage() {
      const message = this.tim.createImageMessage({
        to: this.toAccount,
        conversationType: this.currentConversationType,
        payload: {
          file: document.getElementById("imagePicker"), // 或者用event.target
        },
        onProgress: (percent) => {
          this.$set(message, "progress", percent); // 手动给message 实例加个响应式属性: progress
        },
      });
      this.$store.commit("pushCurrentMessageList", message);
      this.scrollToBottom();
      this.tim
        .sendMessage(message)
        .then(() => {
          this.$refs.imagePicker.value = null;
          this.isEmojiOpen = false;
          this.isMoreOpen = false;
        })
        .catch((imError) => {
          this.$store.commit("showMessage", {
            message: imError.message,
            type: "error",
          });
        });
    },

    //发图片
    handleSendcImageClick() {
      this.$refs.cimagePicker.click();
    },
    sendcImage() {
      const message = this.tim.createImageMessage({
        to: this.toAccount,
        conversationType: this.currentConversationType,
        payload: {
          file: document.getElementById("cimagePicker"), // 或者用event.target
        },
        onProgress: (percent) => {
          this.$set(message, "progress", percent); // 手动给message 实例加个响应式属性: progress
        },
      });
      this.$store.commit("pushCurrentMessageList", message);
      this.scrollToBottom();
      this.tim
        .sendMessage(message)
        .then(() => {
          this.$refs.imagePicker.value = null;
          this.isEmojiOpen = false;
          this.isMoreOpen = false;
        })
        .catch((imError) => {
          this.$store.commit("showMessage", {
            message: imError.message,
            type: "error",
          });
        });
    },

    //滚动到底部
    scrollToBottom() {
      setTimeout(function () {
        $("#message-list").children("div:last-child")[0].scrollIntoView();
      }, 200);
    },

    //下拉刷新
    onRefresh() {
      this.$store.dispatch("getMessageList", this.conversationID);
      this.isLoading = false;
    },
  },
  created() {
    this.headline = this.$route.query.name;
    this.conversationID = this.$route.query.cid;
    if (!this.timeout) {
      this.timeout = setTimeout(() => {
        this.timeout = null;
        this.$store.dispatch("checkoutConversation", this.conversationID);
        this.$nextTick(() => {
          this.scrollToBottom();
        });
      }, 400);
    }
  },
  mounted() {},
};
</script>
<style lang="stylus" scoped>
/* 当前会话的骨架屏 */
.more {
  width: 80px;
  padding: 3px 7px;
  background: rgba(216, 216, 216, 1);
  border-radius: 2px;
  color: #FFFFFF;
  margin: 15px auto;
  display: flex;
  justify-content: center;
  font-size: 12px;
}

.no-more {
  display: flex;
  justify-content: center;
  color: #a5b5c1;
  font-size: 12px;
  padding: 10px 10px;
}

.content {
  display: flex;
  flex: 1;
  flex-direction: column;
  height: 100%;
  overflow: hidden;
  position: relative;

  .message-list {
    width: 100%;
    box-sizing: border-box;
    overflow-y: scroll;
    padding: 0 20px 100px 20px;
  }

  .newMessageTips {
    position: absolute;
    cursor: pointer;
    padding: 5px;
    width: 120px;
    margin: auto;
    left: 0;
    right: 0;
    bottom: 5px;
    font-size: 12px;
    text-align: center;
    border-radius: 10px;
    border: $border-light 1px solid;
    background-color: $white;
    color: $primary;
  }
}
</style>
<style scoped src="../../../static/css/chat.css"></style>
